import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchContainer(container_id) {
    return RequesterV1.get(
      `agro_exporter/production/basic_container_export/manage_container/fetch_container/${container_id}`
    );
  },
  fetchAvailableToAssignExportations(agro_exporter_process_id) {
    return RequesterV1.get(
      `agro_exporter/production/basic_container_export/manage_container/fetch_available_to_assign_exportations/${agro_exporter_process_id}`
    );
  },
  fetchContainerFiles(container_id) {
    return RequesterV1.get(
      `agro_exporter/production/basic_container_export/container_attachments/list_container_files/${container_id}`
    );
  },
  fetchContainerAttachments(container_id) {
    return RequesterV1.get(
      `agro_exporter/production/basic_container_export/container_attachments/${container_id}`
    );
  },
  createContainer(agro_exporter_process_id, container) {
    return RequesterV1.post(
      `agro_exporter/production/basic_container_export/manage_container/create/${agro_exporter_process_id}`,
      { container: container }
    );
  },
  createContainerAttachment(
    container_id,
    exporter_process_container_file_id,
    file
  ) {
    let formData = new FormData();
    formData.append("container_attachment[container_attach]", file || "");
    formData.append(
      "container_attachment[exporter_process_container_file_id]",
      exporter_process_container_file_id
    );
    return RequesterV1.post(
      `agro_exporter/production/basic_container_export/container_attachments/create/${container_id}/`,
      formData
    );
  },
  updateContainer(container_id, container) {
    return RequesterV1.post(
      `agro_exporter/production/basic_container_export/manage_container/update/${container_id}`,
      { container: container }
    );
  },
  destroyContainer(container_id) {
    return RequesterV1.get(
      `agro_exporter/production/basic_container_export/manage_container/destroy/${container_id}`
    );
  },
  destroyContainerAttachment(container_attachment_id) {
    return RequesterV1.get(
      `agro_exporter/production/basic_container_export/container_attachments/destroy/${container_attachment_id}`
    );
  },
  downloadContainerAttachment(container_attachment_id) {
    return RequesterV1.get(
      `agro_exporter/production/basic_container_export/container_attachments/download/${container_attachment_id}`,
      { responseType: "blob" }
    );
  },
  fetchPackingListFormats(agro_exporter_process_id) {
    return RequesterV1.get(
      "agro_exporter/production/basic_container_export/manage_container/fetch_packing_list_formats/" +
        agro_exporter_process_id
    );
  },
  downloadControlUnionRepXlsx({ container_id }) {
    let url = `agro_exporter/production/basic_container_export/manage_container/download_control_union_rep_xlsx/${container_id}`;
    return RequesterV1.get(url, { responseType: "blob" });
  },
  downloadPackingListXlsx(container_id, packing_list_format_id) {
    return RequesterV1.get(
      `agro_exporter/production/basic_container_export/manage_container/download_packing_list_xlsx/${container_id}/${packing_list_format_id}`,
      { responseType: "blob" }
    );
  }
};
